import { useEffect, useRef } from 'react';
/**
 * While enabled, map clicks are handed to `onPick` instead of doing whatever the
 * active map tool would do (normally the crosshairs tool opening a popup).
 *
 * Registers a `nodeMove` tool with `map.toolManager` (see
 * docs/MAP-TOOL-COORDINATION.md) so the other tools stand down while picking,
 * and deactivates it on cleanup, which returns the map to its default tool.
 */
const TOOL_NAME = 'nodeMove';
const PICKING_CLASS = 'node-move-picking';
export function useStructurePick(map, enabled, onPick) {
    // Keep the latest callback without re-registering the tool on every render.
    const onPickRef = useRef(onPick);
    onPickRef.current = onPick;
    useEffect(() => {
        if (!map || !enabled)
            return undefined;
        const container = map.getContainer ? map.getContainer() : null;
        const handleClick = (event) => onPickRef.current(event.latlng);
        const handlers = {
            onActivate: () => {
                map.on('click', handleClick);
                container?.classList.add(PICKING_CLASS);
            },
            onDeactivate: () => {
                map.off('click', handleClick);
                container?.classList.remove(PICKING_CLASS);
            },
        };
        const manager = map.toolManager;
        if (manager) {
            if (manager.tools?.has(TOOL_NAME)) {
                manager.updateHandlers(TOOL_NAME, handlers);
            }
            else {
                manager.register(TOOL_NAME, handlers);
            }
            manager.activate(TOOL_NAME);
        }
        else {
            handlers.onActivate();
        }
        return () => {
            if (manager) {
                // true: return to the default tool, so popups work again.
                manager.deactivate(TOOL_NAME, true);
            }
            else {
                handlers.onDeactivate();
            }
        };
    }, [map, enabled]);
}
export default useStructurePick;
